import * as React from 'react';
import { Wrench } from 'lucide-react';
import { ROLE_VALUES, type CockpitRole } from '@/auth/AuthProvider';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  isDevAuthMode,
  readDevRolePreference,
  writeDevRolePreference,
} from '@/lib/dev-role-preference';

interface DevRoleSelectorProps {
  onChange?: (role: CockpitRole) => void;
}

export function DevRoleSelector({ onChange }: DevRoleSelectorProps): JSX.Element | null {
  const [role, setRole] = React.useState<CockpitRole>(
    () => readDevRolePreference() ?? 'SO-Admin',
  );

  if (!isDevAuthMode()) return null;

  const handleChange = (next: string): void => {
    const nextRole = next as CockpitRole;
    setRole(nextRole);
    writeDevRolePreference(nextRole);
    onChange?.(nextRole);
    window.location.reload();
  };

  return (
    <div className="flex items-center gap-2 rounded-md border border-amber-500/40 bg-amber-500/10 px-2 py-1 text-xs">
      <Wrench className="h-3.5 w-3.5 text-amber-600" />
      <span className="font-semibold uppercase tracking-wide text-amber-700 dark:text-amber-400">
        Dev
      </span>
      <Select value={role} onValueChange={handleChange}>
        <SelectTrigger className="h-7 w-[140px] border-0 bg-transparent px-2 text-xs focus:ring-0">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {ROLE_VALUES.map((r) => (
            <SelectItem key={r} value={r} className="text-xs">
              {r}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
